import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, CalendarDays, ArrowRight, Plus } from "lucide-react";
import { api, formatDate } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { StatusBadge } from "@/components/StatusBadge";
import { PageLoader } from "@/components/layout/RequireAuth";
import { EmptyState } from "@/pages/CategoryPage";

export default function MyRequests() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get("/requests/mine").then((r) => setItems(r.data));
  }, []);

  return (
    <div className="container-page max-w-5xl py-10 lg:py-14" data-testid="my-requests-page">
      <div className="flex flex-col justify-between gap-4 sm:flex-row sm:items-end">
        <div>
          <p className="eyebrow">Pelanggan</p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight text-stone-900 sm:text-4xl">Permintaan Saya</h1>
        </div>
        <Button asChild className="rounded-full bg-teal-700 hover:bg-teal-800" data-testid="my-requests-new-button">
          <Link to="/minta-penawaran"><Plus className="mr-1.5 h-4 w-4" /> Permintaan baru</Link>
        </Button>
      </div>
      <div className="mt-8 space-y-4">
        {items === null ? <PageLoader /> : items.length === 0 ? (
          <EmptyState testId="my-requests-empty" title="Belum ada permintaan" desc="Buat permintaan pertama Anda dan terima penawaran dari penyedia terpercaya."
            action={<Button asChild className="rounded-full bg-teal-700 hover:bg-teal-800"><Link to="/minta-penawaran">Minta Penawaran</Link></Button>} />
        ) : items.map((r) => (
          <Link key={r.request_id} to={`/permintaan/${r.request_id}`} data-testid={`my-request-${r.request_id}`}
            className="card-soft card-lift flex flex-col gap-4 p-5 sm:flex-row sm:items-center sm:p-6">
            <div className="flex-1">
              <div className="flex flex-wrap items-center gap-3">
                <h2 className="text-lg font-bold text-stone-900">{r.category_name}</h2>
                <StatusBadge status={r.status} testId={`my-request-status-${r.request_id}`} />
              </div>
              <p className="mt-1 line-clamp-1 text-sm text-stone-500">{r.description}</p>
              <div className="mt-3 flex flex-wrap gap-x-5 gap-y-1 text-xs text-stone-500">
                <span className="flex items-center gap-1"><MapPin className="h-3.5 w-3.5" /> {r.city_name}</span>
                <span className="flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {formatDate(r.preferred_date)}</span>
                <span>Dibuat {formatDate(r.created_at)}</span>
              </div>
            </div>
            <div className="flex items-center gap-4">
              <div className="text-right">
                <p className="text-2xl font-extrabold text-stone-900" data-testid={`my-request-quote-count-${r.request_id}`}>{r.quote_count}</p>
                <p className="text-xs text-stone-500">penawaran</p>
              </div>
              <ArrowRight className="h-5 w-5 text-stone-400" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
